import {useCallback, useEffect, useState} from 'react';
import {SetterOrUpdater} from 'recoil';
import {useDebounce} from './useDebounce';

export const useDebouncePageable = <T>(pageable: T, setPageable: SetterOrUpdater<T>) => {
  const [pageableToDebounce, setPageableToDebounce] = useState<T>(pageable);
  const debouncedPageable = useDebounce(pageableToDebounce, 500);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPageableToDebounce({...pageableToDebounce, page: newPage});
  };

  const handleChangeRowsPerPage = useCallback((event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setPageableToDebounce({page: 0, size: parseInt(event.target.value, 10)} as T);
  }, []);

  const resetPageable = () => {
    setPageableToDebounce({...pageableToDebounce, page: 0});
  };

  useEffect(() => {
    if (!debouncedPageable) return;
    setPageable((prev) => ({...prev, ...debouncedPageable}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedPageable]);

  return {setPageableToDebounce, pageableToDebounce, handleChangePage, handleChangeRowsPerPage, resetPageable};
};
